export const navLinks = [
  {
    label: "Product Suite",
    dropdown: {
      type: "icon-list",
      columns: 2,
      left : "-left-36",
      width: "w-[1050px]",
      items: [
        {
          heading: "Planning Intelligence",
          options : [
          { label: "Demand Forecasting",               icon: "📈", path: "/product/demand-forecasting" },
          { label: "Inventory Intelligence (MIST)",    icon: "📦", path: "/product/inventory-intelligence" },
          { label: "Order Planning",                   icon: "🗂️", path: "/product/order-planning" },
          ]
        },

          {
          heading: "Execution Systems",
          options : [
        { label: "Lite TMS for SMBs",                icon: "🚚", path: "/product/lite-tms" },
        { label: "Warehouse Management System",      icon: "🏬", path: "/product/warehouse-management" },
        { label: "Dispatch Management System",       icon: "📍", path: "/product/dispatch-management" },
        { label: "Freight Forwarding Platform",      icon: "✈️", path: "/product/freight-forwarding" },
          ]
        },
          {
          heading: "Integration & Automation",
          options : [
          { label: "EDIFAI",                           icon: "🔗", path: "/product/edifai" },
        { label: "AI Rule Engine",                   icon: "⚙️", path: "/product/ai-rule-engine" },
        { label: "Document & Compliance Automation", icon: "📄", path: "/product/document-compliance" },
          ]
        },
          {
          heading: "Financial Intelligence",
          options : [
          { label: "PO & P&L Tracker",                 icon: "💰", path: "/product/po-pl-tracker" },
          ]
        },
          {
          heading: "Visibility & Insights",
          options : [
           { label: "Unified Visibility & Insights",    icon: "🔭", path: "/product/unified-visibility" },
        { label: "CALIO",                            icon: "🗓️", path: "/product/calio" },
        { label: "IQUA",                             icon: "📊", path: "/product/iqua" },
          ]
        },
        {
          heading: "Digital Marketplace & Experience",
          options : [
           { label: "Customer Portal for 3PL",          icon: "🌐", path: "/product/customer-portal" },
        { label: "FairMiles",                        icon: "🛣️", path: "/product/fairmiles" },
          ]
        },
       
      ],
    },
  },
  {
    label: "Services",
    dropdown: {
      type: "cards",
      left : "-left-20",
      footer: { text: "Need a custom solution?", cta: "Contact Us →", path: "/contact" },
      items: [
        { label: "AI-Driven Supply Chain",           icon: "🧠", path: "/service/ai-supply-chain",     desc: "Intelligent, self-optimizing supply chains with AI" },
        { label: "Data Analytics & Forecasting",     icon: "📊", path: "/service/data-analytics",      desc: "Turn data into foresight with predictive analytics" },
        { label: "SAP Consulting & Integration",     icon: "⚙️", path: "/service/sap-consulting",      desc: "Expert SAP implementation, migration & integration" },
        { label: "Salesforce Solutions",             icon: "☁️", path: "/service/salesforce-solutions",desc: "Unify sales, service & marketing with CRM excellence" },
        { label: "Cloud Migration & Modernization",  icon: "🌐", path: "/service/cloud-migration",     desc: "Move to AWS, Azure or GCP with zero downtime" },
        { label: "AI & Automation",                  icon: "🤖", path: "/service/ai-automation",       desc: "Intelligent automation blending RPA and AI" },
      ],
    },
  },
  {
    label: "Industries",
    dropdown: {
      type: "icon-list",
      left : "left-0",
      items: [
        { label: "Manufacturing",                icon: "🏭", path: "/industries/manufacturing" },
        { label: "Pharmaceuticals & Healthcare", icon: "💊", path: "/industries/pharmaceuticals" },
        { label: "Retail & E-Commerce",          icon: "🛒", path: "/industries/retail" },
        { label: "Automotive",                   icon: "🚗", path: "/industries/automotive" },
        { label: "Technology & Electronics",     icon: "💻", path: "/industries/technology" },
        { label: "Food & Agriculture",           icon: "🌾", path: "/industries/sustainability" },
      ],
    },
  },
  {
    label: "Company",
    dropdown: {
      type: "simple",
      left : "left-0",
      items: [
        { label: "About",         path: "/about" },
        { label: "Careers",       path: "/career" },
        { label: "FAQs",          path: "/faq" },
        { label: "Leadership",    path: "/leadership" },
        { label: "News & Events", path: "/events" },
        { label: "Partners",      path: "/partner" },
      ],
    },
  },
];


 const hV = [{
    name: "SAP",
    logo: "https://cdn.hiview.ai/assets/images/SAP.svg"
}, {
    name: "Oracle",
    logo: "https://cdn.hiview.ai/assets/images/Oracle.svg"
}, {
    name: "Shopify",
    logo: "https://cdn.hiview.ai/assets/images/Shopify.svg"
}, {
    name: "Salesforce",
    logo: "https://cdn.hiview.ai/assets/images/Salesforce.svg"
}, {
    name: "EasyPost",
    logo: "https://cdn.hiview.ai/assets/images/EasyPost.png"
}, {
    name: "FedEx",
    logo: "https://cdn.hiview.ai/assets/images/FedEx.svg"
}, {
    name: "Slack",
    logo: "https://cdn.hiview.ai/assets/images/Slack.svg"
}, {
    name: "QuickBooks",
    logo: "https://cdn.hiview.ai/assets/images/QuickBooks.png"
}, {
    name: "PostgreSQL",
    logo: "https://cdn.hiview.ai/assets/images/PostgreSQL.svg"
}, {
    name: "BigQuery",
    logo: "https://cdn.hiview.ai/assets/images/BigQuery.svg"
}, {
    name: "Manhattan",
    logo: "https://cdn.hiview.ai/assets/images/Manhattan.png"
}]
  , mV = [{
    name: "Snowflake",
    logo: "https://cdn.hiview.ai/assets/images/Snowflake.svg"
}, {
    name: "Databricks",
    logo: "https://cdn.hiview.ai/assets/images/Databricks.png"
}, {
    name: "Stripe",
    logo: "https://cdn.hiview.ai/assets/images/Stripe.svg"
}, {
    name: "SendGrid",
    logo: "https://cdn.hiview.ai/assets/images/SendGrid.png"
}, {
    name: "Mailchimp",
    logo: "https://cdn.hiview.ai/assets/images/Mailchimp.png"
}, {
    name: "MongoDB",
    logo: "https://cdn.hiview.ai/assets/images/MongoDB.svg"
}, {
    name: "NetSuite",
    logo: "https://cdn.hiview.ai/assets/images/NetSuite.png"
}, {
    name: "Metabase",
    logo: "https://cdn.hiview.ai/assets/images/Metabase.png"
}, {
    name: "Blue Yonder",
    logo: "https://cdn.hiview.ai/assets/images/BlueYonder.png"
}, {
    name: "Microsoft",
    logo: "https://cdn.hiview.ai/assets/images/Microsoft.svg"
}]